import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
    selector: 'rm-set-production-qty',
    templateUrl: './set-production-qty.component.html',
    styleUrls: ['./set-production-qty.component.css']
})

export class SetProductionQtyComponent implements OnInit {
    form: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<SetProductionQtyComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _formBuilder: FormBuilder,
    ) { }

    ngOnInit(): void {
        // the production quantity can never be below what has already been
        // issued - the server enforces this too, this is just early feedback
        const minQty = this.data.utilisedQty ? Number(this.data.utilisedQty) : 0.000001;

        this.form = this._formBuilder.group({
            totalProductionQty: new FormControl(null, [Validators.required, Validators.min(minQty)])
        });
    }

    get uomLabel(): string {
        return this.data.uom ? this.data.uom : '';
    }

    get utilisedQty(): number {
        return this.data.utilisedQty ? Number(this.data.utilisedQty) : 0;
    }

    cancel() {
        this.dialogRef.close();
    }

    setProductionQty() {
        if (this.form.invalid) {
            return;
        }
        this.dialogRef.close({
            totalProductionQty: Number(this.form.value.totalProductionQty)
        });
    }
}
